export default {
    data: () => ({
        showModalOptInStatus: false,
        showModalOptInContact: null,
        showModalOptInBulkContacts: null,
    }),

    methods: {
        updateState(key, value) {
            this[key] = value;
        },

        async optOut(ids) {
            this.handleShowModalOptInStatus(true, null, ids);
        },

        handleShowModalOptInStatus(status = false, contact = null, bulk = null) {
            this.showModalOptInBulkContacts = bulk;
            this.showModalOptInContact = contact;
            this.showModalOptInStatus = status;
        },
    },
};
